import { initSessionDuration } from 'application/session_duration'

import 'application/application'
import 'shared/flexible_header'
import 'application/ajax'
import 'application/bind_global_dom_events'
import 'application/recaptcha'
import 'application/messaging'
import 'application/popups'
import 'application/utils'

import 'moment'
import '@fancyapps/fancybox'
import 'shared/form_material_design'
import 'shared/go_to_top'
import 'shared/flash_message'
import 'shared/breadcrumbs_flexible'
import 'shared/smart_search'
import 'shared/pingator'
import 'shared/promotion_modal'
import 'application/soft_update'
import 'application/standard_tracking'
import 'application/tracking_link_and_toggle'
import 'application/tracking_form'
import 'application/ga_login_event'
import searchTemplate from 'templates/search_buckets.hbs'

SOPHIA.searchTemplate = searchTemplate

initSessionDuration()
